module.exports = __webpack_public_path__ + "static/media/gallery-rcf.6da4ea89.jpg";